import SetNewPasswordForm from './SetNewPasswordForm';

export default SetNewPasswordForm;
